import type { SeededRandom } from "../core/SeededRandom";
import type { GridMap } from "./GridMap";
import { TileType, type Room } from "./types";

export function carveRoom(grid: GridMap, room: Room, random: SeededRandom): void {
  const phase = random.range(0, Math.PI * 2);
  for (let y = 0; y < room.height; y += 1) {
    for (let x = 0; x < room.width; x += 1) {
      const dx = x - Math.floor(room.width / 2);
      const dy = y - Math.floor(room.height / 2);
      const edgeX = Math.min(x, room.width - 1 - x);
      const edgeY = Math.min(y, room.height - 1 - y);
      let floor = true;
      if (room.shape === "octagon") floor = edgeX + edgeY >= 3;
      if (room.shape === "cross") floor = Math.abs(dx) <= 3 || Math.abs(dy) <= 3;
      if (room.shape === "pillared") floor = !(Math.abs(dx) === 3 && Math.abs(dy) === 3);
      if (room.shape === "cave") {
        const angle = Math.atan2(dy, dx);
        const radius = 0.84 + 0.12 * Math.sin(angle * 3 + phase) + 0.04 * Math.cos(angle * 5);
        floor = Math.hypot(dx / (room.width / 2), dy / (room.height / 2)) <= radius;
        // Preserve broad entrances and continuous routes through the cavern.
        floor ||= Math.abs(dx) <= 1 || Math.abs(dy) <= 1;
      }
      if (floor) grid.set({ x: room.x + x, y: room.y + y }, TileType.Floor);
    }
  }
}
